// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-modal-template-___styles__modalHeader___3kINo{align-items:flex-start;color:#1e2520;display:flex;justify-content:space-between;width:100%}.src-components-modal-template-___styles__modalHeader___3kINo h4{margin:0}.src-components-modal-template-___styles__modalHeader___3kINo img{cursor:pointer;height:18px}.src-components-modal-template-___styles__modalContent___NTiyp{display:block;overflow:initial;padding-top:12px;width:100%}.src-components-modal-template-___styles__modalFooter___3_pMH{display:flex;margin-top:auto;padding-top:24px;width:100%}.src-components-modal-template-___styles__modalOverlay___2951e{align-items:center;background-color:rgba(32,33,38,0.45);display:flex;flex-direction:column;inset:0;justify-content:center;overflow:scroll;padding:32px 0;position:fixed;z-index:300}.src-components-modal-template-___styles__modalOverlay___2951e .src-components-modal-template-___styles__modalContainer___2GN1i{align-items:flex-start;background:#fff none repeat scroll 0% 0%;border-radius:4px;display:flex;flex-direction:column;height:-webkit-max-content;height:-moz-max-content;height:max-content;margin:auto;outline:currentcolor none medium;overflow:initial;padding:24px;position:absolute;top:32px}.src-components-modal-template-___styles__modalOverlay___2951e .src-components-modal-template-___styles__modalContainer___2GN1i p{color:#737474}\n", "",{"version":3,"sources":["webpack://src/components/modal-template/styles.scss"],"names":[],"mappings":"AAA2nC,8DAAa,sBAAsB,CAAC,aAAa,CAAC,YAAY,CAAC,6BAA6B,CAAC,UAAU,CAAC,iEAAgB,QAAQ,CAAC,kEAAiB,cAAc,CAAC,WAAW,CAAC,+DAAc,aAAa,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,UAAU,CAAC,8DAAa,YAAY,CAAC,eAAe,CAAC,gBAAgB,CAAC,UAAU,CAAC,+DAAc,kBAAkB,CAAC,oCAAoC,CAAC,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,sBAAsB,CAAC,eAAe,CAAC,cAAc,CAAC,cAAc,CAAC,WAAW,CAAC,gIAA8B,sBAAsB,CAAC,wCAAwC,CAAC,iBAAiB,CAAC,YAAY,CAAC,qBAAqB,CAAC,0BAAkB,CAAlB,uBAAkB,CAAlB,kBAAkB,CAAC,WAAW,CAAC,gCAAgC,CAAC,gBAAgB,CAAC,YAAY,CAAC,iBAAiB,CAAC,QAAQ,CAAC,kIAAgC,aAAa","sourcesContent":[":export{backgroundGrey:#fafafa;black:#1e2520;blue:#1c5898;boxShadowGrey:rgba(11,9,44,0.2);btnActive:#48813c;btnDefault:#5ca44c;btnDisabled:#d0d0d0;btnGhostActive:rgba(92,164,76,0.25);btnGhostDefault:rgba(0,0,0,0);btnGhostHover:rgba(92,164,76,0.1);btnHover:#529244;btnSecondaryActive:#eaa43b;btnSecondaryDefault:#eaa43b;btnSecondaryDisabled:secondary;btnSecondaryHover:#eaa43b;btnTertiary:rgba(68,69,69,0.75);darkGrey:#737474;errorColor:#cd1515;faintBlue:rgba(28,88,152,0.05);green:#59bf28;grey:#d0d0d0;lightBlue:#2fb4f9;lightGrey:#f1f1f1;olive:#20cb9a;orange:#fe7a24;peach:#fdc;primary:#5ca44c;primary01:rgba(92,164,76,0.1);primaryHover:#529244;red:#fa1931;secondary:#eaa43b;secondary005:rgba(249,183,39,0.05);secondary01:rgba(234,164,59,0.1);success:#5ca44c;tertiary:rgba(68,69,69,0.75);transparent:rgba(0,0,0,0);warning:#ee7b23;white:#fff}:export{inputHeight:38px;l:24px;lFont:18px;m:20px;mFont:16px;mobileBreakpoint:600px;s:16px;sFont:14px;slimButtonHeight:24px;smallestSpacer:5px;spacer:15px;tablet:1024px;xl:28px;xlFont:20px;xs:12px;xsFont:12px;xxl:32px;xxlFont:24px;xxs:8px;xxsFont:10px;xxxl:40px;xxxlFont:28px;xxxs:4px;xxxxl:64px;xxxxs:2px}.modalHeader{align-items:flex-start;color:#1e2520;display:flex;justify-content:space-between;width:100%}.modalHeader h4{margin:0}.modalHeader img{cursor:pointer;height:18px}.modalContent{display:block;overflow:initial;padding-top:12px;width:100%}.modalFooter{display:flex;margin-top:auto;padding-top:24px;width:100%}.modalOverlay{align-items:center;background-color:rgba(32,33,38,0.45);display:flex;flex-direction:column;inset:0;justify-content:center;overflow:scroll;padding:32px 0;position:fixed;z-index:300}.modalOverlay .modalContainer{align-items:flex-start;background:#fff none repeat scroll 0% 0%;border-radius:4px;display:flex;flex-direction:column;height:max-content;margin:auto;outline:currentcolor none medium;overflow:initial;padding:24px;position:absolute;top:32px}.modalOverlay .modalContainer p{color:#737474}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundGrey": "#fafafa",
	"black": "#1e2520",
	"blue": "#1c5898",
	"boxShadowGrey": "rgba(11,9,44,0.2)",
	"btnActive": "#48813c",
	"btnDefault": "#5ca44c",
	"btnDisabled": "#d0d0d0",
	"btnGhostActive": "rgba(92,164,76,0.25)",
	"btnGhostDefault": "rgba(0,0,0,0)",
	"btnGhostHover": "rgba(92,164,76,0.1)",
	"btnHover": "#529244",
	"btnSecondaryActive": "#eaa43b",
	"btnSecondaryDefault": "#eaa43b",
	"btnSecondaryDisabled": "secondary",
	"btnSecondaryHover": "#eaa43b",
	"btnTertiary": "rgba(68,69,69,0.75)",
	"darkGrey": "#737474",
	"errorColor": "#cd1515",
	"faintBlue": "rgba(28,88,152,0.05)",
	"green": "#59bf28",
	"grey": "#d0d0d0",
	"lightBlue": "#2fb4f9",
	"lightGrey": "#f1f1f1",
	"olive": "#20cb9a",
	"orange": "#fe7a24",
	"peach": "#fdc",
	"primary": "#5ca44c",
	"primary01": "rgba(92,164,76,0.1)",
	"primaryHover": "#529244",
	"red": "#fa1931",
	"secondary": "#eaa43b",
	"secondary005": "rgba(249,183,39,0.05)",
	"secondary01": "rgba(234,164,59,0.1)",
	"success": "#5ca44c",
	"tertiary": "rgba(68,69,69,0.75)",
	"transparent": "rgba(0,0,0,0)",
	"warning": "#ee7b23",
	"white": "#fff",
	"inputHeight": "38px",
	"l": "24px",
	"lFont": "18px",
	"m": "20px",
	"mFont": "16px",
	"mobileBreakpoint": "600px",
	"s": "16px",
	"sFont": "14px",
	"slimButtonHeight": "24px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"tablet": "1024px",
	"xl": "28px",
	"xlFont": "20px",
	"xs": "12px",
	"xsFont": "12px",
	"xxl": "32px",
	"xxlFont": "24px",
	"xxs": "8px",
	"xxsFont": "10px",
	"xxxl": "40px",
	"xxxlFont": "28px",
	"xxxs": "4px",
	"xxxxl": "64px",
	"xxxxs": "2px",
	"modalHeader": "src-components-modal-template-___styles__modalHeader___3kINo",
	"modalContent": "src-components-modal-template-___styles__modalContent___NTiyp",
	"modalFooter": "src-components-modal-template-___styles__modalFooter___3_pMH",
	"modalOverlay": "src-components-modal-template-___styles__modalOverlay___2951e",
	"modalContainer": "src-components-modal-template-___styles__modalContainer___2GN1i"
};
export default ___CSS_LOADER_EXPORT___;
